/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" :key="update+'global'">
        <iq-card :class="{ 'remove_card': propOpenedInModal }">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <form action="#" :key="updateAppType">
              <!-- form-row -->
              <div class="form-row">
                <!-- App Type -->
                <div class="col-md-12 mb-3">
                  <label for="app_type">{{ cvExamTypeLabel }}</label>
                  <ValidationProvider name="Quiz Type" rules="required" v-slot="{ errors }">
                    <select :disabled="isAppTypeDisabled" id="app_type" class="form-control" v-model="vmQuizFormData.app_type" @change="update += 1">
                      <option v-for="(Exam_type, index) of QuizType" :key="(index+1)" :value="Exam_type" >
                        {{index}}
                      </option>
                    </select>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- App Type -->

                <!-- App Name -->
                <div class="col-md-12 mb-3">
                  <label for="app_name">{{ cvExamNameLabel }}</label>
                  <ValidationProvider name="Quiz Name" rules="required" v-slot="{ errors }">
                    <input id="app_name" v-model.trim="vmQuizFormData.app_name" type="text" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- App Name -->

                <!-- App name alias-->
                <div class="col-md-12 mb-3">
                  <label for="app_name">{{ cvAliasNamelabel }}</label>
                  <ValidationProvider name="App Name Alias" rules="required"  v-slot="{ errors }">
                    <div class="d-flex align-items-center">
                      <input id="app_name_alias" v-model.trim="vmQuizFormData.app_name_alias" type="text" class="form-control" required />
                    </div>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- App name alias-->

                <!-- Upload Image -->
                <div class="col-md-12">
                  <label>{{ cvPBACoverPic }} : {{ imageSize }}</label>
                  <div class="form-group row align-items-center ml-1">
                    <div class="profile-img-edit border" style="height: 200px; width: 300px;">
                      <img v-if="vmCoverPic" :src="vmCoverPic" alt="profile-pic " style="height: 100%; width: 100%; object-fit: cover; overflow: hidden;" />
                      <i v-else class="fas fa-image d-flex justify-content-center align-items-center" style="font-size: 5rem; height:100%; color: #c1c1c1;"></i>
                      <label class="p-image">
                        <i class="ri-pencil-line upload-button" style="cursor: pointer;"></i>
                        <input class="file-upload" type="file" required accept="image/png,image/jpeg,image/jpg" id="fileInput1" style="display: block; position: absolute; opacity: 0; left: 0; top: 0; pointer-events: none;" @change="openImageDialog($event, 'Cover Pic')" />
                      </label>
                    </div>
                    <span class="text-danger" ref="coverPicError"></span>
                  </div>
                </div><!-- Upload Image -->

                <!-- App/Quiz Description -->
                <div class="col-md-12 mb-3">
                  <label for="validationexam_description">
                    {{ cvExamDescriptionLabel }}
                  </label>
                    <ValidationProvider   name="Quiz Description"
                      rules="required"
                      v-slot="{ errors }"
                    >
                    <vue-editor v-model.trim="vmQuizFormData.app_description"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- App/Quiz Description -->

                <!-- App Instruction -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-md-12 mb-3">
                  <label for="validationapp_instruction">
                    {{ cvAppInstructionLabel }}
                  </label>
                  <vue-editor v-model.trim="vmQuizFormData.app_instruction"></vue-editor>
                </div><!-- App Instruction -->

                <!-- App Direction -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-md-12 mb-3">
                  <label for="validationapp_direction">
                    {{ cvAppDirectionLabel }}
                  </label>
                  <vue-editor v-model.trim="vmQuizFormData.app_direction"></vue-editor>
                </div><!-- App Direction -->

                <!-- App Category -->
                <div class="col-md-12 mb-3">
                  <label for="validationexam_category">{{ cvExamCategoryLabel }} <b v-if="propDuplicateObj.app_category">({{ vmQuizFormData.app_category }})</b></label>
                  <br/>
                  <multiselect
                    v-model="vmQuizFormData.exam_category_option"
                    :options="categoryNames"
                    :multiple="false"
                    :taggable="true"
                    placeholder="Select or add a category"
                    @tag="addNewCategory"
                    >
                  </multiselect>
                </div><!-- App Category -->

                <!-- IS this GIDEPlus Quiz -->
                <div class="col-md-12 mb-3">
                  <label for="app_is_gideplus">{{ cvExamIsGidePlusLabel }}
                    <b v-if="propDuplicateObj.app_is_gideplus">({{propDuplicateObj.app_is_gideplus == 1 ? "Gide+": "For All"}})</b>
                  </label>
                  <ValidationProvider name="Is this a GidePlus Quiz ?" rules="required" v-slot="{ errors }">
                    <multiselect
                      id="app_is_gideplus"
                      v-model="app_is_gideplus"
                      :options="cvExamIsGidePlusOptions"
                      track-by="name"
                      label="name">
                    </multiselect>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- IS this GIDEPlus Quiz -->

                <!-- App Competition Date Time -->
                <div class="col-md-12 mb-3" v-if="vmQuizFormData.app_type == QuizType.COMPETITION">
                  <label for="validationexam_date">{{ cvExamDateLabel }}</label>
                  <ValidationProvider name="Quiz Date" v-slot="{ errors }">
                    <datetime
                      type="datetime"
                      v-model="vmQuizFormData.exam_date"
                      input-class="gide_datetime_input"
                      placeholder="Date month year at time"
                      class="datetime-theme-primary"
                      :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'}"
                      :phrases="{ok: 'Continue', cancel: 'Exit'}"
                      :hour-step="1"
                      :minute-step="5"
                      :week-start="7"
                      use12-hour
                      auto
                      :min-datetime="vmStartDate ? vmStartDate : minStartDate"
                      required>
                    </datetime>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- App Competition Date Time -->

                <!-- Quiz Duration -->
                <div class="col-md-12 mb-3">
                  <label for="app_duration">{{ cvExamDurationLabel }}</label>
                  <ValidationProvider name="Quiz Duration (in seconds)" rules="required" v-slot="{ errors }">
                    <input id="app_duration" v-model="vmQuizFormData.app_duration" placeholder="60" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Quiz Duration -->

                <!-- Per question marks mcq -->
                <div class="col-md-6 mb-3">
                  <label for="app_per_q_marks_mcq">{{ cvMarksPerMCQ }}</label>
                  <ValidationProvider name="M arks for each mcq question" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_per_q_marks_mcq" v-model="vmQuizFormData.app_per_q_marks_mcq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Per question marks mcq -->

                <!-- Per question marks frq -->
                <div class="col-md-6 mb-3">
                  <label for="app_per_q_marks_frq">{{ cvMarksPerFRQ }}</label>
                  <ValidationProvider name="Marks for each frq question" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_per_q_marks_frq" v-model="vmQuizFormData.app_per_q_marks_frq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Per question marks frq -->

                <!-- total mcq questions in app -->
                <div class="col-md-6 mb-3">
                  <label for="app_total_questions_mcq">{{ cvMCQCount }}</label>
                  <ValidationProvider name="MCQ Count" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_total_questions_mcq" v-model="vmQuizFormData.app_total_questions_mcq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- total mcq questions in app -->

                <!-- total frq questions in app -->
                <div class="col-md-6 mb-3">
                  <label for="app_total_questions_frq">{{ cvFRQCount }}</label>
                  <ValidationProvider name="FRQ Count" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_total_questions_mcq" v-model="vmQuizFormData.app_total_questions_frq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- total frq questions in app -->

                <!-- Quiz Total Questions -->
                <div class="col-md-6 mb-3">
                  <label for="app_total_questions">{{ cvExamTotalQuestion }}</label>
                  <ValidationProvider name="Set Total Questions in this Quiz" rules="required" v-slot="{ errors }">
                    <input id="app_total_questions" v-model="vmQuizFormData.app_total_questions" placeholder="1" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Quiz Total Questions -->

                <!-- Quiz Total Score -->
                <div class="col-md-6 mb-3">
                  <label for="validationexam_totalScore">{{ cvExamTotalScore }}</label>
                  <ValidationProvider name="Set Quiz Total Score" rules="required" v-slot="{ errors }">
                    <input id="validationexam_totalScore" v-model="vmQuizFormData.app_total_score" placeholder="100" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Quiz Total Score -->

                <!-- Batch No -->
                <div class="col-md-12 mb-3" v-if="vmQuizFormData.app_type == 'testseries'">
                  <label>{{ cvQuestionBatchNo }}</label>
                  <input v-model="vmQuizFormData.batch_no" type="number" class="form-control" required />
                </div><!-- Batch No -->

                <!-- Quiz Passing Score -->
                <div class="col-md-12 mb-3">
                  <label for="app_passing_score">{{ cvExamPassingScore }}</label>
                  <ValidationProvider name="Set Quiz Passing Score" rules="required" v-slot="{ errors }">
                    <input id="app_passing_score" v-model="vmQuizFormData.app_passing_score" placeholder="50" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Quiz Passing Score -->

                <!-- Is the Quiz Paid -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox" v-if="vmQuizFormData.app_type == QuizType.COMPETITION">
                  <label class="lable" for="app_is_paid">{{ cvExamIsPaid }}</label>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="app_is_paid" v-model="vmQuizFormData.app_is_paid" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Is the Quiz Paid -->

                <div class="col-md-12 mb-3">
                  <label for="validationquestion">
                    {{ cvDifficultyLabel }}</label>
                    <select class="form-control" v-model="vmQuizFormData.difficulty">
                      <option value="easy">Easy</option>
                      <option value="medium">Medium</option>
                      <option value="hard">Hard</option>
                    </select>
                </div>

                <!-- Reference Sheet Image: shown in the Reference popup on the quiz screen (hidden on prod with the new quiz screen) -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-md-12 mb-3">
                  <label for="app_ref_sheet_image">{{ cvAppRefSheetImage }}</label>
                  <select id="app_ref_sheet_image" class="form-control" v-model="vmQuizFormData.app_ref_sheet_image">
                    <option v-for="(refSheetUrl, refSheetKey) in cvRefSheetImgObj" :key="refSheetKey" :value="refSheetUrl">{{ refSheetKey }}</option>
                  </select>
                </div><!-- Reference Sheet Image -->

                <!-- Are questions Shuffled or Ordered -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="is_ques_shuffled" v-model="vmQuizFormData.is_ques_shuffled" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="is_ques_shuffled">{{ cvShuffle }}</label>
                </div><!-- Are questions Shuffled or Ordered -->

                <!-- Interest Id -->
                <div class="col-md-12 mb-3" v-if="vmQuizFormData.app_type == QuizType.TEST_PREP">
                  <label for="validationsubject_module_name">{{cvSubjectNameLabel}}&nbsp;<span class="primary-color" @click="openInterestList">(View Interests)</span></label>
                  <select v-model="vmQuizFormData.interest_id" class="form-control"  style="text-transform: capitalize;">
                    <option  v-for="(subModName, index) of subjectModuleName" :key="(index+1)" :value="subModName" >
                      {{subModName.interest_name}}
                    </option>
                  </select>
                  <span class="primary-color">Note: If you have 4 quizes in a chain that make up a module/test you need to map only the first quiz to an interest</span>
                </div><!-- Interest Id -->

                <!-- Quiz has timer -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="has_timer" v-model="vmQuizFormData.has_timer" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="has_timer">{{ cvConfigureTimer }}</label>
                </div><!-- Quiz has timer -->

                <!-- Allow quiz Resume -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="allow_quiz_resume" v-model="vmQuizFormData.allow_quiz_resume" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label title="This flag indicates, if the quiz in-progress should resume from the last state after browser crash or start a new quiz session" class="lable ml-2" for="allow_quiz_resume">{{ cvAllowQuizResume }}</label>
                </div><!-- Allow quiz Resume -->

                <!-- Show Leaderboard -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <!-- Show Leaderboard -->
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_leaderboard" v-model="vmQuizFormData.show_leaderboard" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_leaderboard">{{ cvShowLeaderboard }}</label>
                </div><!-- Show Leaderboard -->

                <!-- Show Play Again -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_playagain" v-model="vmQuizFormData.show_playagain" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_playagain">{{ cvShowPlayAgain }}</label>
                </div><!-- Show Play Again -->

                <!-- Show rank -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_rank" v-model="vmQuizFormData.show_rank" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_rank">{{ cvShowRank }}</label>
                </div><!-- Show rank -->

                <!-- Show Analysis -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_analysis" v-model="vmQuizFormData.show_analysis" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_analysis">{{ cvShowAnalysis }}</label>
                </div><!-- Show Analysis -->

                 <!-- Is Question Shortcut -->
                 <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="is_question_shortcut" v-model="vmQuizFormData.is_question_shortcut" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="is_question_shortcut">{{ cvIsQuestionShortcut }}</label>
                </div><!-- Is Question Shortcut -->

                <!-- Allow Generates Ans Explanation -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="allow_auto_ans_exp_gen" v-model.trim="vmQuizFormData.allow_auto_ans_exp_gen" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="allow_auto_ans_exp_gen">{{ cvAllowAutoAnsExpGen }}</label>
                </div><!-- Allow Generates Ans Explanation -->

                <!-- Show Results -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_results" v-model="vmQuizFormData.show_results" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_results">{{ cvShowResults}}</label>
                </div><!-- Show Results -->

                <!-- Redirect to thank you page -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="redirect_to_thankyou_page" v-model="vmQuizFormData.redirect_to_thankyou_page" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="redirect_to_thankyou_page">{{ cvRedirectToThankyouPage}}</label>
                </div><!-- Redirect to thank you page -->

                <!-- Quiz ai tutor -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="is_ai_tutor" v-model="vmQuizFormData.is_ai_tutor" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="is_ai_tutor">{{ cvIsAppTutor }}</label>
                </div><!-- Quiz ai tutor -->

                <!-- Split View: checked = Split Screen, unchecked = Full Screen (hidden on prod until the layout switch goes live) -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-12 mb-3 view-type-row">
                  <div class="gide_inline_textorcheckbox">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input id="is_split_view" v-model="vmQuizFormData.is_split_view" type="checkbox" class="form-control" required />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                    <label class="lable ml-2" for="is_split_view">{{ cvIsSplitView }}</label>
                  </div>
                  <span class="view-type-previews">
                    <template v-for="preview in cvViewTypePreviews">
                      <span v-if="!vmViewTypePreviewErr[preview.key]" :key="preview.key" class="view-type-preview" :title="`Click to preview ${preview.label}`" @click="vmViewTypePreview = preview">
                        <img :src="preview.img" :class="['view-type-thumb', { active: (preview.key === 'horizontal') === !!vmQuizFormData.is_split_view }]" :alt="`${preview.label} Preview`" @error="$set(vmViewTypePreviewErr, preview.key, true)" />
                        <small>{{ preview.label }}</small>
                      </span>
                    </template>
                  </span>
                </div><!-- Split View -->

                <!-- GIDE Brand Color: checked = GIDE colors, unchecked = Bluebook colors on the quiz screen (hidden on prod with the new quiz screen) -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <input id="is_gide_brand_color" v-model="vmQuizFormData.is_gide_brand_color" type="checkbox" class="form-control" />
                  <label class="lable ml-2" for="is_gide_brand_color">{{ cvIsGideBrandColor }}</label>
                </div><!-- GIDE Brand Color -->

                <!-- View Type Preview Modal -->
                <b-modal :visible="!!vmViewTypePreview" size="xl" centered hide-footer :title="vmViewTypePreview ? vmViewTypePreview.label : ''" @hidden="vmViewTypePreview = null">
                  <img v-if="vmViewTypePreview" :src="vmViewTypePreview.img" class="w-100" :alt="`${vmViewTypePreview.label} Preview`" />
                </b-modal><!-- View Type Preview Modal -->

                <!-- Redirect URL -->
                <div class="col-md-12 mb-3">
                  <label for="redirect_link">{{ cvRedirectLinkLabel }}</label>
                  <input id="redirect_link" v-model="vmQuizFormData.app_redirect_to_thankyou_page_to_other" type="text" class="form-control" required />
                  <span class="primary-color"><small><i>* With this input you can redirect to a link after thankyou page after 3 seconds</i></small></span>
                </div><!-- Redirect URL -->

                <!-- Is One time Quiz -->
                <!--
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 gide_inline_textorcheckbox">
                  <label class="lable" for="validationexam_name">
                    {{ cvExamIsOneTime }}</label>
                    <ValidationProvider name="Is this a One-Time Quiz ?"
                    rules="required"
                    v-slot="{ errors }">
                  <input v-model="vmQuizFormData.app_is_one_time" type="checkbox" class="form-control" required />
                  <span class="text-danger"> {{ errors[0] }} </span>
                   </ValidationProvider>
                </div> -->

                <div class="col-12 mb-3 mt-4">
                  <label class=""><b>The below configuration is required for GIDE.AI to find the Category of the questions and validate the quality of the Questions to be uploaded</b></label>
                  <label class="" for="app_qbk_category_list">
                    {{ cvAppQuestionTypeCategoryList }}<br>
                    <small>(Example: Data Analysis and Problem Solving, Advanced Math, Geometry and Trigonometry, Algebra, Mathematics)</small>
                  </label>
                  <ValidationProvider
                    name="App Prompt"
                    rules="required"
                    v-slot="{ errors }">
                    <textarea class="textarea form-control" v-model="vmQuizFormData.app_qbk_category_list" required></textarea>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <small class="information-color">* Copy the comma separated list and replace the MACRO {APP_QBK_CATEGORY_LIST} in the textbox below.</small>
                </div>

                <div class="col-12 mb-3">
                  <label class="" for="app_prompt">{{ cvAppPrompt }}</label>
                  <ValidationProvider
                    name="AppPrompt"
                    rules="required"
                    v-slot="{ errors }">
                    <textarea class="textarea form-control" v-model="vmQuizFormData.app_prompt" required></textarea>
                    <small class="information-color">* Replace the known MACROs (Ex. {QUIZ_EXAM_NAME}) or change the prompt as per your requirements</small>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
              </div><!-- form-row -->

              <div class="row spinner_add">
                <div class="col-7">
                  <button type="button" class="btn btn-primary" @click="appAdd()">{{ cvSubmitBtn }}</button>
                </div>
                <div class="col-5">
                  <button v-if="cvLoadingStatus" type="button" class="btn btn-primary float-right" :disabled="cvLoadingStatus">
                    <b-spinner label="Spinning"></b-spinner>
                  </button>
                </div>
              </div>
            </form><!-- form action -->
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <CropImage :prop-crop-image-dialog-open="propCropImageDialogOpen" :propCropModalSize="propCropDialogSize" :prop-stencil-size="propStencilSize" :propSrc="fileSrc" @emitCroppedImg="getCroppedImg" @emitCroppedImgFile="emitCroppedImgFile" />

    <b-toast v-model="showToast" name="Toast" :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<script>
import { Apps } from "../../../FackApi/api/apps.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { VueEditor } from "vue2-editor"
import "vue-datetime/dist/vue-datetime.css"
import { Datetime } from "vue-datetime"
import QuizType from "../../../FackApi/json/QuizType.js"
import { ValidationProvider } from "vee-validate"
import Multiselect from "vue-multiselect"
import CropImage from "../../../components/cropImage.vue"
import { Interests } from "../../../FackApi/api/interest.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import TestSeriesConfigJson from "../../../FackApi/json/TestSeries.json"

export default {
  name: "AppAdd",
  components: {
    VueEditor,
    Datetime,
    ValidationProvider,
    Multiselect,
    CropImage
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propDuplicateObj: {
      type: Object,
      default: function () {
        return {
          "app_name": "",
          "app_name_alias": "",
          "app_description": "",
          "app_category": "",
          "app_date_ts": ""
        }
      }
    }
  },
  data () {
    return {
      apiName: "app_add",
      cvCardTitle: "Add App / Quiz / Game",
      cvSubmitBtn: "Add",
      cvExamNameLabel: "App Name",
      cvAliasNamelabel: "App Name Alias",
      cvExamTypeLabel: "App Type",
      cvExamDescriptionLabel: "App Description",
      cvAppInstructionLabel: "App Instruction",
      cvAppDirectionLabel: "App Direction",
      cvExamCategoryLabel: "App Category",
      cvExamIsGidePlusLabel: "App Is Gideplus ?",
      cvRedirectLinkLabel: "Redirect After Thankyou",
      cvExamDateLabel: "App Date",
      cvExamDurationLabel: "App Duration(in second)",
      cvExamTotalQuestion: "Ques Per Quiz",
      cvExamTotalScore: "App Total Score (100, 50 ,20)",
      cvExamPassingScore: "App Passing Score",
      cvShuffle: "Show questions shuffled ?",
      cvShowAnalysis: "Show Analysis",
      cvIsQuestionShortcut: "Show Ques. No. Dropdown",
      cvConfigureTimer: "Show timer for this Quiz ?",
      cvAllowQuizResume: "Reload Quiz Session",
      cvShowLeaderboard: "Show Leaderboard",
      cvShowPlayAgain: "Show Play Again Button",
      cvShowRank: "Show Rank",
      cvShowResults: "Show Results",
      cvRedirectToThankyouPage: "Redirect to Thank You Page",
      cvIsAppTutor: "Enable AI Tutor?",
      cvIsSplitView: "Split View (Question & Options Side by Side)",
      cvIsGideBrandColor: "GIDE Brand Color on Quiz Screen",
      cvAppRefSheetImage: "Reference Sheet",
      cvRefSheetImgObj: TestSeriesConfigJson.REF_SHEET_IMG_OBJ,
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      cvViewTypePreviews: [
        { key: "horizontal", label: "Horizontal View (Default)", img: "https://gide-assets.s3.us-east-1.amazonaws.com/quiz-horizontal-view.png" },
        { key: "vertical", label: "Vertical View", img: "https://gide-assets.s3.us-east-1.amazonaws.com/quiz-vertical-view.png" }
      ],
      vmViewTypePreview: null,
      vmViewTypePreviewErr: {},
      cvExamIsPaid: "App Is Paid ?",
      cvAllowAutoAnsExpGen: "Allow AI to Generate Answer Explanation",
      // cvExamIsOneTime: "Quiz Is One Time ?",
      cvExamImage: "App image",
      cvDifficultyLabel: "App/Quiz Difficulty",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "App",
      vmQuizFormData: Object.assign({}, this.initFormData()),
      vmQuizDesc: null,
      vmQuizType: null,
      subjects: [],
      subjectModules: [],
      vmqbkExamCategoryList: " ",
      categoryNames: [],
      datetimeEmpty: "",
      vmStartDate: null,
      minStartDate: null,
      app_is_gideplus: false,
      QuizType: QuizType,
      cvExamIsGidePlusOptions: [
        {
          name: "For All"
        },
        {
          name: "Gide+"
        }
      ],
      cvPBACoverPic: "Does this App have a Picture ? If yes then upload ",
      propCropDialogSize: "md",
      propCropImageDialogOpen: false,
      vmCoverPic: "",
      propStencilSize: null,
      fileSrc: "",
      vmPBACoverPicImage: Object.assign({}, this.initImageData()),
      isPhotoUploaded: false,
      imageMaxSize: " Maximum Size 4MB",
      imageSize: "Size  1080 * 566",
      update: 0,
      isAppTypeDisabled: false,
      cvQuestionBatchNo: "Set the batch no. of this Quiz. A quiz like MOCK TEST can have multiple batches. This field defines the group/batch number of the quiz",
      cvImageSizeErrorMsg: " Image size must be less than 300 kb.",
      updateAppType: 0,
      cvAppQuestionTypeCategoryList: "App Questions Category List",
      cvAppPrompt: "Prompt to validate the question and determine the exact category and difficulty level of the questions",
      appPrompt: "For this {QUIZ_EXAM_NAME} evaluate and analyse the question to find the following - difficulty level as difficulty from the option: easy, medium, difficult, find skills tested by the question as skill, find the single most best matching category for this question as qbk_category from the following options: {APP_QBK_CATEGORY_LIST}. Also find if the question meets the standards of this exam/quiz as is_standard with boolean response along with the reason as is_standard_reason. All the response should be in JSON format, for the following question: {QUESTION} on {QUIZ_NAME}",
      cvMarksPerMCQ: "Marks Per MCQ",
      cvMarksPerFRQ: "Marks Per FRQ",
      cvMCQCount: "Total MCQ Questions",
      cvFRQCount: "Total FRQ Questions",
      subjectModuleName: [],
      cvSubjectNameLabel: "Interest/Subject/Exam Name"
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
    this.interestList()
  },
  mounted () {
    if (this.propDuplicateObj && this.propDuplicateObj.app_id) {
      this.vmQuizFormData = {
        ...this.propDuplicateObj,
        app_id: this.propDuplicateObj.app_id.replace(/copy$/i, "") + " copy",
        app_name: this.propDuplicateObj.app_name.replace(/copy$/i, "") + " copy"
      }
    }

    socialvue.index()
    this.QuizType = QuizType(this.userData.user_role)
    this.appCategoryDistinct()

    if (this.$route.path.split("/").includes("tprep_quiz_dashboard")) {
      this.vmQuizFormData.app_type = this.QuizType.TEST_PREP
      this.isAppTypeDisabled = true
    }

    // Create the prompt
    this.appPrompt = this.vmQuizFormData.app_name_alias ? this.appPrompt.replace("{QUIZ_NAME}", this.vmQuizFormData.app_name_alias) : this.appPrompt
    this.appPrompt = this.vmQuizFormData.app_qbk_category_list ? this.appPrompt.replace("{APP_QBK_CATEGORY_LIST}", this.vmQuizFormData.app_qbk_category_list) : this.appPrompt
    this.vmQuizFormData.app_prompt = this.vmQuizFormData.app_prompt ? this.vmQuizFormData.app_prompt : this.appPrompt

    this.updateAppType = 1
  },
  methods: {
    /**
     * interestList
     */
    async interestList () {
      try {
        let interestListResp = await Interests.interestWithCategoryList(this, {}, "INTERESTCAT11117")
        if (interestListResp.resp_status) {
          this.subjectModuleName = interestListResp.resp_data.INTERESTCAT11117
        }
        else {
          this.toastMsg = interestListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at interestList() and Exception:", err.message)
      }
    },
    /**
     * addNewCategory
     */
    addNewCategory (category) {
      this.categoryNames.push(category)
      this.vmQuizFormData.exam_category_option = category
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        "app_type": QuizType.QUIZ,
        "app_name": "",
        "app_description": "",
        "app_instruction": "",
        "app_direction": "",
        "app_category": "",
        "app_date_ts": "",
        "app_total_questions": "",
        "app_total_score": "",
        "app_passing_score": "",
        "app_duration": 60,
        "subject_name": "",
        "subject_module_name": "",
        "is_ques_shuffled": 0,
        "is_split_view": 1,
        "is_gide_brand_color": 0,
        "app_ref_sheet_image": "",
        "show_analysis": "",
        "is_question_shortcut": "",
        "allow_auto_ans_exp_gen": "",
        "show_results": "",
        "app_prompt": "",
        "app_qbk_category_list": "",
        "app_per_q_marks_mcq": 1,
        "app_per_q_marks_frq": 1,
        "app_total_questions_mcq": 0,
        "app_total_questions_frq": 0
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmQuizFormData) {
          if (!this.vmQuizFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * initImageData
     */
    initImageData () {
      return {
        image: "",
        image_type: ""
      }
    },
    /**
     * initPBAData
     */
    initPBAData () {
      return {
        question_name: "",
        module_id: ""
      }
    },
    /**
     * appCategoryDistinct
     */
    async appCategoryDistinct () {
      try {
        const resp = await Apps.appCategoryDistinct(this)
        this.categoryNames = resp.resp_data.data.map(d => d.app_category)
      }
      catch (err) {
        console.error("Exception occurred at appCategoryDistinct() and Exception:", err.message)
      }
    },
    /**
     * appAdd
     */
    async appAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true

        this.vmQuizFormData.app_date_ts = this.vmQuizFormData.exam_date ? Math.floor(new Date(this.vmQuizFormData.exam_date).getTime() / 1000) : null
        this.vmQuizFormData.app_is_gideplus = this.app_is_gideplus.name === "Gide+" ? 1 : 0
        this.vmQuizFormData.app_is_one_time = this.vmQuizFormData.app_is_one_time === true ? 1 : 0
        this.vmQuizFormData.app_is_paid = this.vmQuizFormData.app_is_paid === true ? 1 : 0
        this.vmQuizFormData.is_question_shortcut = this.vmQuizFormData.is_question_shortcut === true ? 1 : 0
        this.vmQuizFormData.allow_auto_ans_exp_gen = this.vmQuizFormData.allow_auto_ans_exp_gen === true ? 1 : 0

        // If app instruction has only spaces/empty tags then clear it so the quiz shows the app description
        const appInstruction = this.vmQuizFormData.app_instruction || ""
        if (!appInstruction.replace(/<[^>]*>|&nbsp;/g, "").trim()) {
          this.vmQuizFormData.app_instruction = ""
        }

        // If app direction has only spaces/empty tags then clear it so the quiz shows the default directions
        const appDirection = this.vmQuizFormData.app_direction || ""
        if (!appDirection.replace(/<[^>]*>|&nbsp;/g, "").trim()) {
          this.vmQuizFormData.app_direction = ""
        }

        if (this.vmQuizFormData.app_qbk_category_list) {
          this.vmQuizFormData.app_qbk_category_list = this.vmQuizFormData.app_qbk_category_list.replace(/\s*,\s*/g, ",")
        }
        else {
          this.vmQuizFormData.app_qbk_category_list = ""
        }

        if (this.vmQuizFormData.exam_category_option !== "AddNew") {
          this.vmQuizFormData.app_category = this.vmQuizFormData.exam_category_option
        }

        if (this.vmQuizFormData.interest_id) {
          this.vmQuizFormData.interest_id = this.vmQuizFormData.interest_id.interest_id
        }

        let quizAddResp = await Apps.appAdd(this, this.vmQuizFormData)
        ApiResponse.responseMessageDisplay(this, quizAddResp)
        if (quizAddResp && !quizAddResp.resp_status) {
          return false
        }

        if (this.isPhotoUploaded) {
          let imageAddResp = await this.imageAdd(quizAddResp.resp_data.app_id)
          if (imageAddResp && imageAddResp.resp_status) {
            quizAddResp.resp_data.app_image = imageAddResp.resp_data[0].image
          }
          this.isPhotoUploaded = false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          // when the data moves first time from add it gives app_date_ts in string that gives invalid date error
          quizAddResp.resp_data.app_date_ts = parseInt(quizAddResp.resp_data.app_date_ts)
          this.$emit("emitCloseQuizAddModal", quizAddResp.resp_data)
        }

        if (quizAddResp.resp_status) {
          let path = ""
          if (quizAddResp.resp_data.app_type === QuizType.COMPETITION) {
            // Goto evet edit page to edit the event and to let the user know that a competition related event has been created
            path = "/event_edit/" + quizAddResp.resp_data.app_id
          }
          else {
            // Goto the Quizbank page for thr user to uplaod questions
            path = "/quizBank_add/" + quizAddResp.resp_data.app_id
          }
          this.$router.push(path)
        }

        this.vmQuizFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at appAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * openImageDialog
     *
     */
    openImageDialog (e, imageType) {
      this.isPhotoUploaded = true
      this.updateImageType = imageType
      if (e.target.files.length > 0) {
        this.fileSrc = e.target.files[0]
      }
      let input = e.target
      if (input.files.length > 0 && input.files[0]) {
        let image = input.files[0]
        let allowedExtension = [ "image/png", "image/jpg", "image/jpeg", "image/webp" ]
        let maxSize = 300 * 1024 // 300 KB in bytes
        if (!allowedExtension.includes(image.type)) {
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          return false
        }
        else if (image.size > maxSize) {
          // validate image size
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.toastVariant = "danger"
            this.showToast = true
          }
          return false
        }
        this.propStencilSize = {
          "width": 1080,
          "height": 566
        }
        this.propCropDialogSize = "md"
        this.propCropImageDialogOpen = Math.random()
      }
    },
    /**
     * getCroppedImg
     */
    getCroppedImg (img) {
      if (this.updateImageType === "Profile Pic") {
        this.vmProfilePic = img
      }
      else {
        this.vmCoverPic = img
      }
    },
    /**
     * emitCroppedImgFile
     */
    emitCroppedImgFile (imgObj) {
      let img = imgObj.imgFile
      let orgImg = imgObj.orgImage
      let imageType = this.updateImageType
      this.onChangeProfileImage(img, imageType)
      this.vmPBACoverPicImage = Object.assign({}, this.initImageData())
      this.vmPBACoverPicImage.image = {
        "img": img,
        "name": orgImg.name
      }
      this.vmPBACoverPicImage.image_type = "cover_pic"
    },

    /**
     * onChangeProfileImage
     */
    onChangeProfileImage (e, imageType) {
      try {
        const reader = new FileReader()
        reader.onload = async (e) => {
          if (imageType === "Profile Pic") {
            this.vmProfilePic = await reader.result
          }
          else {
            this.vmCoverPic = await reader.result
          }
        }
        // reader.readAsDataURL(image)
      }
      catch (err) {
        console.error("Exception occurred at onChangeProfilePic() and Exception:", err.message)
      }
    },
    /**
     * imageAdd
     */
    async imageAdd (appId) {
      if (this.cvImageError) {
        return
      }

      try {
        this.cvImageLoadingStatus = true
        let imageObj = {
          "module_name": "APPS",
          "module_id": appId,
          "image": []
        }

        if (this.vmPBACoverPicImage.image) {
          imageObj.image.push(this.vmPBACoverPicImage)
        }

        if (imageObj.image.length < 1) {
          return false
        }

        const imageUpdateResp = await Apps.imageAddToApp(this, imageObj)
        await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
        if (imageUpdateResp && !imageUpdateResp.resp_status) {
          return false
        }

        this.vmPBACoverPicImage = Object.assign({}, this.initPBAData())
        imageObj = {}
        return imageUpdateResp
      }
      catch (err) {
        console.error("Exception occurred at imageAdd() and Exception:", err.message)
        return err
      }
      finally {
        this.cvImageLoadingStatus = false
      }
    },

    /**
     * appTotalQuestionScoreSet
     * Sets the app_total_question and app_total_score form fields as app_per_q_marks_mcq, app_per_q_marks_frq, app_total_questions_mcq, app_total_questions_frq changes
     */
    appTotalQuestionScoreSet () {
      const vmQuizFormDataCopy = { ...this.vmQuizFormData }
      vmQuizFormDataCopy.app_total_questions = Number(this.vmQuizFormData.app_total_questions_mcq) + Number(this.vmQuizFormData.app_total_questions_frq)
      vmQuizFormDataCopy.app_total_score = (Number(this.vmQuizFormData.app_per_q_marks_mcq) * Number(this.vmQuizFormData.app_total_questions_mcq)) + (Number(this.vmQuizFormData.app_per_q_marks_frq) * Number(this.vmQuizFormData.app_total_questions_frq))

      this.vmQuizFormData = vmQuizFormDataCopy
    },
    /**
     * open Interest List
     */
    openInterestList () {
      window.open("interest_list", "_blank")
    }
  }
}
</script>
<style scoped>
  .textarea{
    width: 50%;
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
  .view-type-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 24px;
    row-gap: 8px;
  }
  .view-type-previews {
    display: inline-flex;
    gap: 16px;
  }
  .view-type-preview {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: zoom-in;
  }
  .view-type-preview small {
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
  }
  .view-type-thumb {
    height: 45px;
    width: 80px;
    object-fit: cover;
    object-position: top;
    border: 1px solid #b5b5b5;
    border-radius: 4px;
  }
  .view-type-preview:hover .view-type-thumb,
  .view-type-thumb.active {
    border-color: var(--iq-primary);
  }
</style>
